import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import appReducer from './slices/appSlice';
import projectsReducer from './slices/projectsSlice';
import chatReducer from './slices/chatSlice';
import chatsReducer from './slices/chatsSlice';
import previewReducer from './slices/previewSlice';
import walletReducer from './slices/walletSlice';
import agentReducer from './slices/agentSlice';
import memoryReducer from './slices/memorySlice';
import { saveAppState } from '../utils/storage';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    app: appReducer,
    projects: projectsReducer,
    chat: chatReducer,
    chats: chatsReducer,
    preview: previewReducer,
    wallet: walletReducer,
    agent: agentReducer,
    memory: memoryReducer
  }
});

store.subscribe(() => {
  saveAppState(store.getState());
});
